import { IAppState } from '@app/store/state/app.state';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import * as ErrorActions from '@store/actions/error.actions';
import { logoutRequest } from '@store/actions/auth.actions';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store<IAppState>) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.error?.code === 'SESSION_INVALID') {
          // Only the response for the current session may sign the user out.
          // Concurrent failures and late responses must not repeat the notice
          // or invalidate a newer login. Keep the error for feature cleanup.
          const currentToken = localStorage.getItem('id_token');
          if (currentToken && request.headers.get('Authorization') === `Bearer ${currentToken}`) {
            this.store.dispatch(logoutRequest());
            this.store.dispatch(ErrorActions.addGlobalErrorMessage({
              errorMessage: 'Your session has ended. Please sign in again.',
            }));
          }
          return throwError(error);
        }

        // check for internet connection
        if (!navigator.onLine) {
          console.warn('No internet connection');
        }

        console.log(error);
        // let errorMessage = '';
        // if (error.error instanceof ErrorEvent) {
        //   // client-side error
        //   errorMessage = `Error: ${error.error.message}`;
        // } else {
        //   // server-side error
        //   errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        // }

        // handle HTTP errors
        switch (error.status) {
          case 403:
            // do something else
            console.error('403 error. Insufficient permissions');
            break;
          case 404:
            // do something else
            console.log('404 error');
            break;
          default:
          // default behavior
        }
        this.store.dispatch(ErrorActions.addGlobalError({ error }));
        return throwError(error);
      })
    );
  }
}
